import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            About Me
          </p>
        </div>

        <p className="text-xl mt-20">
        I'm committed to continuous learning, always adapting to the latest technological advancements in software engineering. 
        My approach includes valuing diverse perspectives, understanding that everyone has something to teach. 
        This mindset positions me as a collaborative and forward-thinking team member, ready to make a significant impact in the tech world and beyond.
        </p>

        <br />

        <p className="text-xl">
          Outside of programming,  I am deeply fascinated by the cosmos. I hope to one day be able to combine my passions for software engineering and space,
          aiming to forge a unique career path at the intersection of these two exciting fields.
        </p>
      </div>
    </div>
  );
};

export default About;
